import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.9822 9.26748H1.27654C0.571528 9.26748 0 8.69595 0 7.99094C0 7.28592 0.571528 6.71439 1.27654 6.71439H10.9853L8.33806 3.95417C7.84037 3.40279 7.87755 2.77501 8.33806 2.32689C8.79857 1.8767 9.57504 1.90561 10.0066 2.32689C10.4382 2.74816 14.6551 7.17569 14.6551 7.17569C14.8844 7.39872 15 7.69403 15 7.98933C15 8.28257 14.8844 8.57788 14.6551 8.80297C14.6551 8.80297 10.4382 13.2305 10.0066 13.6497C9.57504 14.071 8.79857 14.0999 8.33806 13.6497C7.87755 13.2016 7.84037 12.5738 8.33806 12.0245L10.9822 9.26748Z",
		fill: "currentColor"
	})
});
export default SvgIconArrowRight;
